"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.zListTechniciansQuery = exports.zUpdateTechnicianRequest = exports.zCreateTechnicianRequest = void 0;
const zod_1 = require("zod");
const query_params_js_1 = require("./query-params.js");
const editableFields = {
    displayName: zod_1.z.string().trim().min(1),
    code: zod_1.z.string().trim().min(1).nullable().optional(),
    userId: zod_1.z.number().int().positive().nullable().optional(),
};
exports.zCreateTechnicianRequest = zod_1.z.object(editableFields);
exports.zUpdateTechnicianRequest = zod_1.z.object(editableFields).partial();
exports.zListTechniciansQuery = zod_1.z.object({
    search: zod_1.z.string().trim().min(1).optional(),
    includeInactive: query_params_js_1.zBooleanQueryParam.default(false),
    limit: zod_1.z.coerce.number().int().min(1).max(100).default(25),
    offset: zod_1.z.coerce.number().int().min(0).default(0),
});
//# sourceMappingURL=technicians.js.map